<template>
  <div
    id="app"
    v-hb-loading.fullscreen.lock="showLoading"
    hb-loading-circle-bg="#DADDE0"
    hb-loading-color="#64696E"
  >
    <hb-share-header
      :title="user_name + '邀请你使用小黑盒'"
      desc="3亿Steam玩家的必备应用——小黑盒，快来下载~"
      :shareConfig="shareConfig"
      pageKey="fd_coupon"
      @click.capture.native="reportShare('download')"
    />
    <div class="texture">
      <img
        src="https://cdn.max-c.com/heybox/app/game_buy_share/bg_texture.png"
        alt=""
      />
    </div>
    <div class="logo">
      <img
        src="https://cdn.max-c.com/heybox/app/game_buy_share/heybox_logo_white.png"
        alt=""
      />
    </div>
    <div class="title">
      <img
        src="https://cdn.max-c.com/heybox/app/game_buy_share/share_title.png"
        alt=""
      />
    </div>
    <div class="game-wrapper">
      <div class="wrapper">
        <div class="avatar">
          <img :src="avatar" alt="" />
        </div>
        <h2>
          <span>{{ user_name }}</span
          >邀请你使用小黑盒
        </h2>
        <p>邀请码</p>
        <div class="invitation">
          <h3>{{ invite_num }}</h3>
        </div>
        <p>下载APP后在注册页面输入</p>
      </div>
    </div>
    <div class="desc">
      <p>规则说明：</p>
      <p>1. 下载小黑盒并在注册时填写邀请码后，即可获得5元优惠券及H币奖励</p>
      <p>2. 同一设备注册只能使用邀请码一次</p>
      <p>
        3.
        下载注册小黑盒app，完成Steam账号（与邀请您的好友有Steam好友关系的Steam账号）绑定，即可帮助您的好友获得专属福利，您也将获得专属新人优惠礼包。
      </p>
    </div>
  </div>
</template>
<script>
import { utils } from '_lib/utils';
import { getShareInviteInfo } from '_api/tools/invite-friend.js';
export default {
  data() {
    return {
      showLoading: true,
      avatar: '',
      user_name: '',
      invite_num: '-',
      shareConfig: null,
      weixindata: null,
    };
  },
  created() {
    this.getData();
    this.reportShare('visit');
  },
  methods: {
    getData() {
      getShareInviteInfo({
        heybox_id: utils.getUrlParam('heybox_id'),
      }).then(({ data }) => {
        if (data.status == 'ok') {
          const result = data.result;

          this.avatar = result.avatar;
          this.user_name = result.user_name;
          this.invite_num = result.invite_num;

          this.weixindata = result.weixindata;
          if (this.weixindata && Object.keys(this.weixindata).length > 0) {
            this.shareConfig = {
              title: this.user_name + '邀请你使用小黑盒',
              desc: '3亿Steam玩家的必备应用——小黑盒，快来下载~',
              link: window.location.href,
              imgUrl: 'http://cdn.max-c.com/heybox/heybox_share.jpg',
              appId: 'wxe8989eb8b38b5c4d',
            };
          }

          this.showLoading = false;
        }
      });
    },
    reportShare(action) {
      this.$reportShare({
        action,
        source: '/tools/invite_friend',
      });
    },
  },
};
</script>
<style lang="less">
@import '~_style/common.css';
#app {
  max-width: 480px;
  margin: 0 auto;
  background: #ac5fd2
    url('https://cdn.max-c.com/heybox/app/game_buy_share/bg.jpg') no-repeat;
  background-size: cover;
  padding: 0 30px 30px;
  overflow: hidden;
  min-height: calc(100vh - 50px);
  .texture {
    position: fixed;
    width: 100%;
    bottom: 0;
    left: 0;
    z-index: 99;
    img {
      width: 100%;
    }
  }
  .logo {
    width: 64px;
    margin: 1.625rem auto 0;
    img {
      width: 100%;
    }
  }
  .title {
    width: 100%;
    margin: 0 0 2rem;
    height: 0;
    padding-top: 23.72%;
    overflow: hidden;
    position: relative;
    z-index: 100;
    img {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
    }
  }
  .game-wrapper {
    width: 100%;
    padding-top: 70%;
    position: relative;
    border-radius: 6px;
    overflow: hidden;
    margin: 0 auto 2.5rem;
    z-index: 100;
    background-color: rgba(255, 255, 255, 1);
    .wrapper {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background: url('https://cdn.max-c.com/heybox/app/game_buy_share/share_texture.png')
        no-repeat;
      background-size: 100% 100%;
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-orient: vertical;
      -webkit-flex-direction: column;
      -ms-flex-direction: column;
      flex-direction: column;
      -webkit-box-pack: center;
      -webkit-justify-content: center;
      -ms-flex-pack: center;
      justify-content: center;
      -webkit-box-align: center;
      -webkit-align-items: center;
      -ms-flex-align: center;
      align-items: center;
      .avatar {
        width: 19%;
        height: 0;
        padding-top: 19%;
        position: relative;
        margin: 0 auto 1rem;
        border-radius: 50%;
        overflow: hidden;
        margin: 0 auto 0.875rem;
        img {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
        }
      }
      .invitation {
        margin: 0.625rem 0;
        background-color: #fff;
        padding: 0.625rem 1.75rem;
        box-shadow: 0 0 2px 2px rgba(219, 184, 254, 0.16);
        display: inline-block;
        line-height: 1;
        margin: 0.375rem 0;
        padding: 0.5rem 1.5rem;
        h3 {
          margin: 0;
          line-height: 1;
          font-size: 1rem;
        }
      }
      h2 {
        text-align: center;
        color: #14191e;
        font-size: 1rem;
        font-weight: 500;
        margin: 0 0 1rem;
        line-height: 1;
        span {
          margin-right: 5px;
        }
      }
      p {
        font-size: 0.75rem;
        color: #5d6164;
        text-align: center;
      }
    }
  }
  .desc {
    width: 100%;
    position: relative;
    z-index: 100;
    p {
      color: #fff;
      line-height: 17px;
      font-size: 0.75rem;
      text-align: left;
      font-weight: 200;
    }
  }
}

@media screen and (max-width: 374px) {
  .game-wrapper .wrapper h2 {
    font-size: 0.875rem;
    margin-bottom: 0.5rem;
  }
  .game-wrapper .wrapper .avatar {
    margin: 0 auto 0.875rem;
  }
  .game-wrapper .wrapper .invitation {
    margin: 0.375rem 0;
    padding: 0.5rem 1.5rem;
  }
  .game-wrapper .wrapper .invitation h3 {
    font-size: 1rem;
  }
}

.hb-share-header {
  top: auto;
  bottom: 0;
  background: #2b2440;
  border: none;
}
</style>
